import { onCLS, onFID, onFCP, onLCP, onTTFB, onINP } from 'web-vitals'

interface Metric {
  name: string
  value: number
  rating: 'good' | 'needs-improvement' | 'poor'
  delta?: number
  id: string
  navigationType?: string
}

type MetricHandler = (metric: Metric) => void

function sendToAnalytics(metric: Metric) {
  // Send to your analytics endpoint
  const analyticsUrl = import.meta.env.VITE_ANALYTICS_URL
  
  if (analyticsUrl) {
    fetch(analyticsUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(metric),
      keepalive: true,
    }).catch((err) => {
      console.warn('Failed to send metric to analytics:', err)
    })
  }

  // Log to console in development
  if (import.meta.env.DEV) {
    console.log(`[Web Vital] ${metric.name}:`, metric)
  }
}

export function reportWebVitals(onReport?: MetricHandler) {
  const handler = onReport || sendToAnalytics

  onCLS(handler)
  onFID(handler)
  onFCP(handler)
  onLCP(handler)
  onTTFB(handler)
  onINP(handler)
}

export function measureAPILatency(url: string, duration: number) {
  // Send to backend for monitoring
  if (duration > 300) {
    console.warn(`[Performance] Slow API: ${url} took ${duration}ms`)
  }

  // Report to analytics if configured
  const analyticsUrl = import.meta.env.VITE_ANALYTICS_URL
  if (analyticsUrl) {
    fetch(analyticsUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        name: 'api-latency',
        url,
        value: duration,
        timestamp: Date.now(),
      }),
      keepalive: true,
    }).catch(() => {
      // Silently fail - don't block the app
    })
  }
}

export function measureRenderTime(componentName: string, startTime: number) {
  const duration = performance.now() - startTime
  
  if (import.meta.env.DEV) {
    console.log(`[Render] ${componentName}: ${duration.toFixed(2)}ms`)
  }

  if (duration > 100) {
    console.warn(`[Performance] Slow render: ${componentName} took ${duration.toFixed(2)}ms`)
  }
}
